const styles = theme => ({
  root: {},
  drawer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "75vw",
    maxWidth: 350
  },
  drawerPaper: {
    overflowX: "hidden"
  },
  user: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: `${theme.spacing(4)}px ${theme.spacing(2)}px`,
    background: theme.palette.primary.main,
    // "@supports (padding-top: constant(safe-area-inset-top))": {
    //   "--safe-area-inset-top": "constant(safe-area-inset-top)",
    //   paddingTop: `calc(${theme.spacing(3)}px + var(--safe-area-inset-top))`
    // },
    // "@supports (padding-top: env(safe-area-inset-top))": {
    //   "--safe-area-inset-top": "env(safe-area-inset-top)",
    //   paddingTop: `calc(${theme.spacing(3)}px + var(--safe-area-inset-top))`
    // }
    [theme.breakpoints.down("sm")]: {
      minHeight: "130px"
    }
  },
  avatarProfile: {
    width: 65,
    height: 65,
    background: theme.palette.secondary.light,
    color: theme.palette.primary.main
  },
  userTitle: {
    color: "#fff",
    fontSize: 16
  },
  userSubTitle: {
    color: "rgba(255, 255, 255, .56)",
    fontSize: 14
  },
  orgPanel: {
    margin: 0,
    "&.MuiExpansionPanel-root.Mui-expanded": {
      margin: 0
    }
  },
  selectedOrgContainer: {
    paddingLeft: 0,
    "&>.MuiExpansionPanelSummary-content.Mui-expanded": {
      margin: `${theme.spacing(1.5)}px 0`
    }
  },
  selectedOrg: {
    paddingTop: 0,
    paddingBottom: 0,
    color: theme.palette.primary.default
  },
  notSelectedOrg: {
    color: theme.palette.primary.default
  },
  avatarSelectedOrg: {
    width: 68,
    height: 60,
    borderRadius: "10px"
  },
  avatarOrg: {
    width: 58,
    height: 50,
    borderRadius: "10px"
  },
  orgList: {
    flexDirection: "column"
  },
  addOrg: {
    width: "100%",
    "&> button": {
      padding: `${theme.spacing(2)}px 0`,
      width: "100%",
      background: theme.palette.primary.main,
      color: "#fff",
      fontSize: 16,
      fontWeight: 700,
      borderRadius: 0,
      "&:hover": {
        background: theme.palette.primary.main
      }
    }
  },
  addIcon: {
    marginRight: theme.spacing(1)
  },
  drawerBottom: {
    "@media only screen and (max-width: 480px)": {
      position: "fixed",
      width: "75vw",
      bottom: "0",
      backgroundColor: "white",
      alignItems: "center"
    },
    display: "flex",
    flexDirection: "column",
    flex: 1,
    justifyContent: "flex-end"
  },
  logoTextContainer: {
    display: "flex",
    justifyContent: "center",
    width: "100%"
  },
  logoText: {
    width: "50%",
    height: "100%"
  },
  version: {
    padding: theme.spacing(1),
    color: theme.palette.primary.default,
    "@supports (padding-bottom: constant(safe-area-inset-bottom))": {
      "--safe-area-inset-bottom": "constant(safe-area-inset-bottom)",
      paddingBottom: "var(--safe-area-inset-bottom)"
    },
    "@supports (padding-bottom: env(safe-area-inset-bottom))": {
      "--safe-area-inset-bottom": "env(safe-area-inset-bottom)",
      paddingBottom: "var(--safe-area-inset-bottom)"
    }
  },
  listItemTextColor: {
    color: theme.palette.primary.default
  },
  iconColor: {
    color: theme.palette.primary.default
  },
  logoutContainer: {
    [theme.breakpoints.down("sm")]: {
      marginBottom: "100px"
    }
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/AppDrawer/styles.js